export const previewContent = {
    id : "66434d3ae06b8d60a3eeeee4",
    chats : [
      {
        "id": "66434d3ae06b8d60a3eeeee4",
        "question": "What is Seek?",
        "citations": [],
        "answer": "Seek leverages uploaded content to provide contextual insights to your users.",
        "session": "66434d3ae06b8d60a3eeeee4",
        "contentMappings": [
          {
              "id": null,
              "uid": "asset_662cc67c7726a260b1e16866",
              "type": "ASSET",
              "content": {
                  "id": "662cc67c7726a260b1e16866",
                  "name": null,
                  "entityType": "asset",
                  "source": "CLEVERSTORY",
                  "seekStatus": null,
                  "seekEnabled": false,
                  "asset": {
                      "id": "662cc659b888b157c6155b8d",
                      "name": "Marketing Campaign Per...",
                      "entityType": "asset",
                      "alias": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1-ylxn8w",
                      "summary": null,
                      "metadata": {
                          "content_type": "application/pdq",
                          "modified_date": 1714210393000,
                          "url": "5c5e8b6b46e0fb000131662c/assets/b2591ac5-dd55-4204-9bff-a701b414ed21.pdf",
                          "md5_checksum": null,
                          "original_name": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1.pdf",
                          "content_length": 15746706,
                          "extension": "pdf",
                          "etag": "74bf655d5ad187e928161adccbc199fe",
                          "pages": 28,
                          "read_time": 806.218487394958
                      },
                      "icon": {
                          "id": "662cc6c6997e4a204cfff6d7",
                          "type": "image",
                          "thumbnail": "/images/seek/pdfThumbnail.jpg",
                          "full": "https://dwoemqguc7qqj.cloudfront.net/5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c",
                          "key": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
                      },
                  }
              },
              "fields": [
                  {
                      "name": "name",
                      "content": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1",
                      "custom": false,
                      "override": false,
                      "desktop": true,
                      "mobile": true
                  },
                  {
                      "name": "description",
                      "content": null,
                      "custom": false,
                      "override": false,
                      "desktop": true,
                      "mobile": true
                  },
                  {
                      "name": "icon",
                      "content": {
                          "id": "662cc6c6997e4a204cfff6d7",
                          "name": null,
                          "contentType": null,
                          "type": "image",
                          "width": 0,
                          "height": 0,
                          "url": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
                      },
                      "custom": false,
                      "override": false,
                      "desktop": true,
                      "mobile": true
                  },
                  {
                      "name": "contentType",
                      "content": "PDF",
                      "custom": false,
                      "override": false,
                      "desktop": true,
                      "mobile": true
                  },
                  {
                      "name": "fileSize",
                      "content": "15 MB",
                      "custom": false,
                      "override": false,
                      "desktop": true,
                      "mobile": true
                  },
                  {
                      "name": "author",
                      "content": "",
                      "custom": false,
                      "override": false,
                      "desktop": true,
                      "mobile": true
                  }
              ],
              "url": "/media/f3c58b1e-d84d-4309-b11e-3ccb46a632f1-9atxz0",
              "order": 0,
              "override": false
          },
          {
            "id": null,
            "uid": "asset_662cc67c7726a260b1e16865",
            "type": "ASSET",
            "content": {
                "id": "662cc67c7726a260b1e16865",
                "name": null,
                "entityType": "asset",
                "source": "CLEVERSTORY",
                "gatingConfigurations": [],
                "customFields": null,
                "tags": null,
                "disableDownload": false,
                "excludeFromSearch": false,
                "seekStatus": null,
                "seekEnabled": false,
                "asset": {
                    "id": "662cc659b888b157c6155b8d",
                    "name": "Sales Pitch Deck for Q3...",
                    "entityType": "asset",
                    "alias": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1-ylxn8w",
                    "summary": null,
                    "metadata": {
                      "content_type": "video/mp4",
                      "modified_date": 1714210393000,
                      "url": "5c5e8b6b46e0fb000131662c/assets/b2591ac5-dd55-4204-9bff-a701b414ed21.pdf",
                      "md5_checksum": null,
                      "original_name": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1.pdf",
                      "content_length": 15746706,
                      "extension": "Video",
                      "etag": "74bf655d5ad187e928161adccbc199fe",
                      "pages": 28,
                      "read_time": 806.218487394958
                    },
                    "icon": {
                        "id": "662cc6c6997e4a204cfff6d7",
                        "type": "image",
                        "thumbnail": "/images/seek/videoThumbnail.jpg",
                        "full": "https://dwoemqguc7qqj.cloudfront.net/5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c",
                        "key": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
                    },
                }
            },
            "fields": [
                {
                    "name": "name",
                    "content": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1",
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "description",
                    "content": null,
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "icon",
                    "content": {
                        "id": "662cc6c6997e4a204cfff6d7",
                        "name": null,
                        "contentType": null,
                        "type": "image",
                        "width": 0,
                        "height": 0,
                        "url": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
                    },
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "contentType",
                    "content": "PD",
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "fileSize",
                    "content": "15 MB",
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "author",
                    "content": "",
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                }
            ],
            "url": "",
            "order": 0,
            "override": false
          },
          {
            "id": null,
            "uid": "asset_662cc67c7726a260b1e16863",
            "type": "ASSET",
            "content": {
                "id": "662cc67c7726a260b1e16863",
                "name": null,
                "entityType": "asset",
                "source": "CLEVERSTORY",
                "gatingConfigurations": [],
                "customFields": null,
                "tags": null,
                "disableDownload": false,
                "excludeFromSearch": false,
                "seekStatus": null,
                "seekEnabled": false,
                "asset": {
                    "id": "662cc659b888b157c6155b8",
                    "name": "Customer Engagement Metrics...",
                    "entityType": "asset",
                    "alias": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1-ylxn8w",
                    "summary": null,
                    "metadata": {
                        "content_type": "application/vnd.google-apps.presentation",
                        "modified_date": 1714210393000,
                        "url": "5c5e8b6b46e0fb000131662c/assets/b2591ac5-dd55-4204-9bff-a701b414ed21.pdf",
                        "md5_checksum": null,
                        "original_name": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1.pdf",
                        "content_length": 15746706,
                        "extension": "PPT",
                        "etag": "74bf655d5ad187e928161adccbc199fe",
                        "pages": 28,
                        "read_time": 806.218487394958
                    },
                    "icon": {
                        "id": "662cc6c6997e4a204cfff6d7",
                        "type": "image",
                        "thumbnail": "/images/seek/pptThumbnail.jpg",
                        "full": "https://dwoemqguc7qqj.cloudfront.net/5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c",
                        "key": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
                    },
                }
            },
            "fields": [
                {
                    "name": "name",
                    "content": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1",
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "description",
                    "content": null,
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "icon",
                    "content": {
                        "id": "662cc6c6997e4a204cfff6d7",
                        "name": null,
                        "contentType": null,
                        "type": "image",
                        "width": 0,
                        "height": 0,
                        "url": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
                    },
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "contentType",
                    "content": "PDF",
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "fileSize",
                    "content": "15 MB",
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                },
                {
                    "name": "author",
                    "content": "",
                    "custom": false,
                    "override": false,
                    "desktop": true,
                    "mobile": true
                }
            ],
            "url": "/media/f3c58b1e-d84d-4309-b11e-3ccb46a632f1-9atxz0",
            "order": 0,
            "override": false
          }
        ]
      }
    ],
    sessionId: '66434d3ae06b8d60a3eeeee2'
  }